import type { CustomThemeConfig } from '@iheartjane/reefer';

import {
  KioskTypographyVariantConfig,
  KioskVariantComponentMap,
} from './typography';

export const defaultTheme: CustomThemeConfig = {
  borderRadius: {
    xl: '64px',
  },
  components: {
    Button: {
      icons: {
        sizes: {
          default: {
            borderRadius: 'xl',
            height: 64,
          },
          jumbo: {
            borderRadius: 'xl',
            height: 84,
          },
          large: {
            height: 80,
          },
          small: {
            height: 40,
          },
        },
      },
      sizes: {
        default: {
          borderRadius: 'sm',
          height: 64,
          paddingX: 24,
          typographyVariant: 'body-semibold',
        },
        jumbo: {
          borderRadius: 'xl',
          height: 120,
          paddingX: 48,
          typographyVariant: 'h1-semibold',
        },
        large: {
          borderRadius: 'sm',
          height: 80,
          paddingX: 32,
          typographyVariant: 'h4-semibold',
        },
        small: {
          borderRadius: 'xs',
          height: 48,
          paddingX: 16,
          typographyVariant: 'small-body-semibold',
        },
      },
    },
    Checkbox: {
      size: '32px',
      tapTarget: '48px',
    },
    Icon: {
      sizes: {
        lg: '32px',
        md: '24px',
        sm: '16px',
        xl: '48px',
        xxl: '64px',
        xxxl: '80px',
      },
    },
    Typography: {
      componentMapping: KioskVariantComponentMap,
      fonts: {},
      variants: KioskTypographyVariantConfig,
    },
  },
};
